import { RootState } from '../../../../utils/type';

export const selectVendorChargerStatus = (state: RootState) => state.vendorChargerStatus.data;
export const selectVendorChargerStatusLoading = (state: RootState) => state.vendorChargerStatus.loading;
export const selectVendorChargerStatusError = (state: RootState) => state.vendorChargerStatus.error;
